import { useSidebarDndContext } from "@/contexts/SidebarDndProvider";
import { cn } from "@/lib/utils";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export function SortableThreadItemInline({ thread, workspaceId, children }) {
  const { isThreadMoving } = useSidebarDndContext();

  // Disable dragging if this thread is currently being moved
  const isMoving = isThreadMoving ? isThreadMoving(thread.id) : false;
  const disabled = isMoving;

  // Use namespaced ID to prevent cross-interference with project page sortable
  const sortableId = `sidebar-${thread.id}`;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: sortableId,
    disabled,
    data: {
      type: "chat",
      item: thread,
      workspaceId,
      source: "sidebar",
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  // Prevent drag when clicking on interactive elements or when disabled
  const handlePointerDown = (e) => {
    if (disabled) {
      return; // Don't allow drag if thread is being moved
    }
    if (
      e.target.closest("button") ||
      e.target.closest("a") ||
      e.target.closest("[role='button']") ||
      e.target.closest(".dropdown-menu-item") ||
      e.target.closest(".thread-menu-trigger") ||
      e.target.closest("input") ||
      e.target.closest("textarea")
    ) {
      return;
    }
    if (listeners?.onPointerDown) {
      listeners.onPointerDown(e);
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      tabIndex={-1}
      {...listeners}
      onPointerDown={handlePointerDown}
      className={cn(
        "w-full",
        !disabled && "cursor-grab active:cursor-grabbing",
        disabled && "cursor-not-allowed opacity-60",
        isDragging && "opacity-50 z-50",
        isMoving && "pointer-events-none"
      )}
      title={isMoving ? "Moving..." : undefined}
    >
      {children}
    </div>
  );
}
